module.exports = __webpack_public_path__ + "static/media/me-img-3.32258ae6.jpeg";